import React from 'react';
import { CssBaseline, Box } from '@mui/material';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ThemeProvider, useTheme } from './theme/ThemeContext';
import { getTheme } from './theme/theme';
import ParticleBackground from './components/ParticleBackground';
import ThemeToggle from './components/ThemeToggle';
import ROICalculator from './components/ROICalculator';

function AppContent() {
    const { mode } = useTheme();
    const theme = getTheme(mode);

    return (
        <MuiThemeProvider theme={theme}>
            <CssBaseline />
            <ParticleBackground />
            <Box
                sx={{
                    position: 'relative',
                    minHeight: '100vh',
                    bgcolor: 'transparent',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        bgcolor: mode === 'light'
                            ? 'rgba(255, 255, 255, 0.9)'
                            : 'rgba(45, 52, 54, 0.95)',
                        zIndex: -1,
                    },
                }}
            >
                {/* Theme Toggle */}
                <Box
                    sx={{
                        position: 'fixed',
                        top: 16,
                        right: { xs: 16, sm: 24 },
                        zIndex: 1100,
                    }}
                >
                    <ThemeToggle />
                </Box>

                {/* Main Content */}
                <ROICalculator />
            </Box>
        </MuiThemeProvider>
    );
}

function App() {
    return (
        <ThemeProvider>
            <AppContent />
        </ThemeProvider>
    );
}

export default App;
